import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_heat-dispatch/artifacts/5ljah6z6_image.png";

export default function AdminLogin() {
  const [email, setEmail] = useState("admin@mcflysfuel.com");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/admin/login", { email, password });
      localStorage.setItem("mcfly_admin_token", data.token);
      toast.success("Welcome back, dispatcher.");
      nav("/admin");
    } catch {
      toast.error("Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-brand-navy text-white flex items-center justify-center px-4 relative overflow-hidden" data-testid="admin-login-page">
      <div className="absolute inset-0 grid-lines opacity-20"></div>
      <div className="relative w-full max-w-md">
        <Link to="/" className="flex items-center gap-3 mb-8 group">
          <img src={LOGO_URL} alt="McFly's Fuel Inc." className="h-14 w-auto block" />
          <div className="font-heading text-xl">Dispatch Panel</div>
        </Link>

        <div className="bg-white text-foreground p-8 offset-shadow">
          <div className="text-[11px] uppercase tracking-[0.25em] text-brand-red font-bold mb-2">Restricted</div>
          <h1 className="font-heading text-3xl mb-6">Admin sign-in</h1>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="text-[11px] uppercase tracking-[0.2em] font-bold text-muted-foreground">Email</label>
              <input value={email} onChange={(e)=>setEmail(e.target.value)} required type="email" className="mt-1 w-full border border-input px-3 py-2.5 focus:outline-none focus:ring-2 focus:ring-brand-red" data-testid="admin-email" />
            </div>
            <div>
              <label className="text-[11px] uppercase tracking-[0.2em] font-bold text-muted-foreground">Password</label>
              <input value={password} onChange={(e)=>setPassword(e.target.value)} required type="password" className="mt-1 w-full border border-input px-3 py-2.5 focus:outline-none focus:ring-2 focus:ring-brand-red" data-testid="admin-password" />
            </div>
            <button disabled={loading} type="submit" className="w-full bg-brand-red hover:bg-brand-redDark text-white font-bold py-3 inline-flex items-center justify-center gap-2" data-testid="admin-login-submit">
              {loading && <Loader2 className="animate-spin" size={16} />}
              Sign in
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
